module.exports = __webpack_public_path__ + "img/punt_right.526a2607.jpg";